import { Text,Flex, CloseButton,Spacer, Center} from '@chakra-ui/react'

const ComponentHeader = ({onClosePress,component}) => {
    
    return (
        
            
            <Flex direction={'row'} h='40px' alignItems={'center'}>
                    <Center>
                <Text color='grunt2.800' fontSize={'2xl'} pl='2'>
                    {component.ico}
                    
                </Text>
                <Text color='grunt2.800' fontSize={'2xl'} pl='5'>
                {component.caption}
                </Text>
                </Center>
                <Spacer/>
                
                <CloseButton size={'md'} color={'grunt2.800'} mr='3' onClick={onClosePress}/>
                
            </Flex>
            
        
    );
}

export default ComponentHeader;
